import React, { Fragment, useState } from "react";
import ModalVideo from "react-modal-video";
import Header2 from "../../components/header/Header2";
import Scrollbar from "../../components/WhatsAppBtn/WhatsAppBtn";
import Footer from "../../components/footer/Footer";
import CtaSection from "../../components/CtaSection/CtaSection";
import Bg from "../../images/bg/page_bg01.jpg";
import icon from "../../images/icon/ser-01.svg";
import sImg1 from "../../images/icon/sd-icon01.svg";
import sImg2 from "../../images/icon/sd-icon02.svg";
import sImg3 from "../../images/icon/sd-icon03.svg";
import sImg4 from "../../images/icon/sd-icon04.svg";
import shape from "../../images/shape/sd-shape.png";
import sicon from "../../images/icon/check-icon.svg";
import bannerDevWeb from "../../images/banners/banner_web_dev.png";

const DesenvolvimentoWebPage = (props) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <Fragment>
      <div className="sco_agency">
        <Header2 />
        <main className="page_content service-single-page">
          <section
            className="page-title pt-200 pos-rel bg_img"
            style={{ backgroundImage: `url(${Bg})` }}
          >
            <div className="container">
              <div className="page-title-wrap sd-title-wrap">
                <div className="row mt-none-30 align-items-center justify-content-center">
                  <div className="col-lg-10 col-xl-8 mt-30">
                    <div className="page-title-box">
                      <span className="sub-title">
                        <img src={icon} alt="" /> Desenvolvimento Web
                      </span>
                      <h2 className="title">
                        Soluções digitais personalizadas <br /> com tecnologia
                        de ponta <br /> e hospedagem otimizada
                      </h2>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="video pt-70 pb-65">
            <div className="container">
              <div className="xb-video sd-video image-only pos-rel">
                <img src={bannerDevWeb} alt="Desenvolvimento Web Banner" />
              </div>
            </div>
          </div>
          <div className="sd-ser-content_wrap pb-110">
            <div className="container">
              <div className="sd-ser-content">
                <h2 className="sd-title">
                  Desenvolvimento Web Somar: Transformação Digital Completa
                </h2>
                <p className="sd-content">
                  O Desenvolvimento Web da Somar Cloud oferece soluções digitais
                  completas e personalizadas, desde websites institucionais
                  modernos até sistemas web complexos e e-commerce avançado.
                  Utilizamos tecnologias de ponta como React, Node.js, PHP,
                  Python e frameworks modernos, garantindo que sua presença
                  digital seja profissional, responsiva e otimizada para
                  conversão.
                </p>
                <br />
                <p className="sd-content">
                  Nossa abordagem full-stack inclui design UX/UI responsivo,
                  desenvolvimento backend robusto, integração com APIs e
                  sistemas legados, otimização para SEO, e hospedagem em nossa
                  infraestrutura cloud de alta performance. Todos os projetos
                  são desenvolvidos com metodologia ágil, testes automatizados,
                  e documentação completa, garantindo qualidade e facilidade de
                  manutenção.
                </p>
                <br />
                <p className="sd-content">
                  <strong>Diferenciais exclusivos Somar:</strong> Hospedagem
                  incluída em nossa infraestrutura cloud otimizada, SSL
                  gratuito, CDN nacional para máxima velocidade, backup
                  automático de código e dados, monitoramento 24/7 de uptime, e
                  suporte técnico especializado. Combinamos desenvolvimento de
                  classe mundial com hospedagem de alta performance em uma
                  solução integrada única no mercado.
                </p>
              </div>
            </div>
          </div>
          <div className="sd-process_warp">
            <div className="container">
              <div className="sd-heading">
                <h2 className="sd-title">Metodologia de Desenvolvimento</h2>
                <p className="sd-content">
                  Nossa metodologia ágil garante entrega de soluções web
                  modernas, funcionais e otimizadas, com acompanhamento
                  transparente em todas as etapas.
                </p>
              </div>
              <div className="sd-process_inner ul_li">
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg1} alt="" />
                  </div>
                  <h3 className="xb-item--title">Discovery e Planejamento</h3>
                  <p className="xb-item--contact">
                    Análise de requisitos e definição de arquitetura técnica.
                  </p>
                  <span className="xb-item--number">01</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg2} alt="" />
                  </div>
                  <h3 className="xb-item--title">Design e Prototipagem</h3>
                  <p className="xb-item--contact">
                    Criação de wireframes, design responsivo e protótipos
                    interativos.
                  </p>
                  <span className="xb-item--number">02</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg3} alt="" />
                  </div>
                  <h3 className="xb-item--title">Desenvolvimento Ágil</h3>
                  <p className="xb-item--contact">
                    Codificação com entregas iterativas e testes contínuos.
                  </p>
                  <span className="xb-item--number">03</span>
                </div>
                <div className="sd-process-item">
                  <div className="xb-item--icon">
                    <img src={sImg4} alt="" />
                  </div>
                  <h3 className="xb-item--title">Deploy e Manutenção</h3>
                  <p className="xb-item--contact">
                    Lançamento na cloud Somar com suporte e atualizações
                    contínuas.
                  </p>
                  <span className="xb-item--number">04</span>
                </div>
                <div className="sd-shape">
                  <img src={shape} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="sd-service_wrap pt-115 pb-130">
            <div className="container">
              <div className="sd-ser-outcome">
                <div className="sd-heading">
                  <h2 className="sd-title">
                    Vantagens do Desenvolvimento Somar
                  </h2>
                  <p className="sd-content">
                    Transforme sua presença digital com soluções web modernas e
                    hospedagem de alta performance, tudo integrado em uma
                    solução completa.
                  </p>
                </div>
                <div className="sd-list-item ul_li">
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Tecnologias modernas (React, Node.js, PHP, Python)
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Design responsivo e otimizado para conversão
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Hospedagem cloud incluída na infraestrutura Somar
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      SSL gratuito e CDN nacional
                    </li>
                  </ul>
                  <ul className="sd-ser-list list-unstyled">
                    <li>
                      <img src={sicon} alt="" />
                      Otimização para SEO e performance
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Backup automático e monitoramento 24/7
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Metodologia ágil com entregas iterativas
                    </li>
                    <li>
                      <img src={sicon} alt="" />
                      Suporte técnico especializado contínuo
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </main>
        <CtaSection />
      </div>
      <Footer />
      <Scrollbar />
      <ModalVideo
        channel="youtube"
        autoplay
        isOpen={isOpen}
        videoId="7e90gBu4pas"
        onClose={() => setOpen(false)}
      />
    </Fragment>
  );
};

export default DesenvolvimentoWebPage;
